<template>
  <AppFooterDrawer app>
    <FooterRB />
  </AppFooterDrawer>
</template>

<script>
import AppFooterDrawer from "@/components/ui/app/AppFooterDrawer";
import FooterRB from "./FooterRB";

export default {
  name: "TheFooter",
  components: {
    AppFooterDrawer,
    FooterRB
  },
  props: {
    nav: Array
  }
};
</script>

<style lang="scss">
.the-footer {
  position: relative;
}
</style>
